export const gradients = {
  simple: {
    value: 'linear-gradient(180deg, #000000 0%, #041b2f 100%)',
  },
} as const;
